import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import { useContext } from 'react';
import { useHeaderTopContext } from 'palette/HeaderTop/context';
import { Icon } from 'palette/Icon';
import {
    Modal, ModalBox, ModalBoxBody, ModalBoxHeader, ModalContext,
} from 'palette/Modal';
import { Transition } from 'palette/Transition';
import { BodyText } from 'palette/Typography';
import { Languages } from './types';
import './styles/LanguageSelector.scss';

interface LanguageSelectorProps {
    languages: Languages;
    activeLanguage: string;
    store: string;
    title: string;
    subTitle: string;
    modalId: string;
    className: string;
}

export function LanguageSelector({
    className,
    modalId,
    languages,
    activeLanguage,
    store,
    title,
    subTitle,
} : LanguageSelectorProps) {
    const { isLanguageSelectorActive, setIsLanguageSelectorActive } = useHeaderTopContext();
    const [block, BEMElement] = BEMBlock('language-selector');
    const { activeModalId } = useContext(ModalContext);
    const showModalBox = modalId === activeModalId;

    const handleOpen = () => { setIsLanguageSelectorActive(true); };
    const handleClose = () => { setIsLanguageSelectorActive(false); };

    return (
        <>
            <Transition
                appear
                show={showModalBox}
                timeout="quick"
                onEnter={handleOpen}
                onExited={handleClose}
            >
                <ModalBox
                    className={classNames(className, block)}
                    isActive={isLanguageSelectorActive}
                >
                    <ModalBoxHeader
                        className={BEMElement('header')}
                        subtitle={subTitle}
                        title={title}
                    />
                    <ModalBoxBody className={BEMElement('body')}>
                        {languages[store].map((language) => {
                            const countrySlug = language.code === 'en' ? 'uk' : language.country;

                            return (
                                <a
                                    key={language.id}
                                    className={BEMElement('item', { active: language.code === activeLanguage })}
                                    href={showModalBox ? language.url : ''}
                                    id={`${store}-${language.id}`}
                                >
                                    <div className={BEMElement('language')}>
                                        {/* @ts-ignore */}
                                        <Icon name={`flag_${countrySlug}`} />
                                        <BodyText
                                            className={BEMElement('language-text')}
                                        >
                                            {language.title}
                                        </BodyText>
                                    </div>
                                    <Icon
                                        className={BEMElement('check', { active: language.code === activeLanguage })}
                                        name="palette_check"
                                    />
                                </a>
                            );
                        })}
                    </ModalBoxBody>
                </ModalBox>
            </Transition>
            <Modal id={modalId} />
        </>
    );
}
